/**
 * The same numbers a chart draws, as a real table, for people who cannot read a chart and for anyone who wants the exact figures. Collapsed by default
 * (native <details>, so it is keyboard- and screen-reader-operable without script). Every chart on a dashboard should have one.
 */
export function ChartDataTable({
  caption, rows, total, formatValue,
}: {
  caption: string;
  rows: { label: string; value: number; note?: string | undefined }[];
  total?: { label: string; value: number } | undefined;
  formatValue: (value: number) => string;
}) {
  return (
    <details className="ed-chart-table">
      <summary>View as table</summary>
      <table>
        <caption>{caption}</caption>
        <thead>
          <tr><th scope="col">Item</th><th scope="col" className="ed-chart-table__num">Amount</th></tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.label}>
              <th scope="row">{r.label}{r.note && <span className="ed-chart-table__note"> {r.note}</span>}</th>
              <td className="ed-chart-table__num">{formatValue(r.value)}</td>
            </tr>
          ))}
        </tbody>
        {total && (
          <tfoot>
            <tr><th scope="row">{total.label}</th><td className="ed-chart-table__num">{formatValue(total.value)}</td></tr>
          </tfoot>
        )}
      </table>
    </details>
  );
}
